import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const req = require.context('./modules', false, /\.js$/);
const requireAll = (requireContext) => {
  const files = requireContext.keys();
  return files.reduce((modules, f) => {
    const mod = f.slice(f.lastIndexOf('/') + 1, f.lastIndexOf('.js'));
    modules[mod] = requireContext(f);
    modules[mod] = modules[mod].default ? modules[mod].default : modules[mod];
    modules[mod].namespaced =
      modules[mod].namespaced !== undefined ? modules[mod].namespaced : true;
    return modules;
  }, {});
};

const modules = requireAll(req);

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  state,
  mutations,
  actions,
  getters,
});
